module.exports = __webpack_public_path__ + "static/assets/7c9cb56f3756d2687a0c77335dfaf4ba.svg";